export default {
  "menu.welcome": "Welcome",
  "menu.home": "Home",
  "menu.login": "Login",
  "menu.register": "Register",
  "menu.register-result": "Register Result",

  // Dashboard
  "menu.dashboard": "Dashboard",
  "menu.dashboard.workplace": "Workplace",
  "menu.dashboard.business-data": "Business Data",
  "menu.dashboard.device-monitor": "Device Monitor",
  "menu.workplace": "Workplace",
  "menu.business-data": "Business Data",
  "menu.device-monitor": "Device Monitor",

  // Management
  "menu.management": "Tea House Management",
  "menu.management.store": "Store Management",
  "menu.management.product": "Product Management",
  "menu.management.room": "Room Management",
  "menu.management.set-meal": "Set Meal Management",
  "menu.orders": "Order Management",
  "menu.orders.all": "All Orders",

  // Personnel
  "menu.personnel": "Personnel Management",
  "menu.personnel.employee": "Employee Management",
  "menu.personnel.member": "Member Management",

  // Transaction
  "menu.transaction": "Transaction",
  "menu.transaction.orders": "Order Management",
  "menu.transaction.orders.orders-user": "User Orders",
  "menu.transaction.orders.orders-invoice": "Invoice Management",
  "menu.transaction.coupon": "Coupon Management",
  "menu.transaction.coupon.coupon-templates": "Coupon Templates",
  "menu.transaction.coupon.user-coupons": "Sold Coupons",

  // Content
  "menu.content": "Operations Configuration",
  "menu.content.news": "Updates Management",
  "menu.content.miniapp-config": "Mini App Config",
  "menu.content.member-level": "Member Levels",

  // Reference
  "menu.reference": "Reference",

  // List Reference
  "menu.list-ref": "List Reference",
  "menu.table-list": "Table List",
  "menu.basic-list": "Basic List",
  "menu.card-list": "Card List",
  "menu.search-list": "Search List",
  "menu.articles": "Search List (Articles)",
  "menu.projects": "Search List (Projects)",
  "menu.applications": "Search List (Applications)",

  // Form Reference
  "menu.form-ref": "Form Reference",
  "menu.basic-form": "Basic Form",
  "menu.step-form": "Step Form",
  "menu.advanced-form": "Advanced Form",

  // Profile Reference
  "menu.profile-ref": "Profile Reference",
  "menu.basic-profile": "Basic Profile",
  "menu.advanced-profile": "Advanced Profile",

  // Result Reference
  "menu.result-ref": "Result Reference",
  "menu.success": "Success",
  "menu.fail": "Fail",

  // Exception Reference
  "menu.exception-ref": "Exception Reference",
  "menu.err403": "403",
  "menu.err404": "404",
  "menu.err500": "500",

  // Nested Menu Paths
  "menu.reference.list-ref": "List Reference",
  "menu.reference.list-ref.table-list": "Table List",
  "menu.reference.list-ref.basic-list": "Basic List",
  "menu.reference.list-ref.card-list": "Card List",
  "menu.reference.list-ref.search-list": "Search List",
  "menu.reference.list-ref.search-list.articles": "Search List (Articles)",
  "menu.reference.list-ref.search-list.projects": "Search List (Projects)",
  "menu.reference.list-ref.search-list.applications": "Search List (Applications)",
  "menu.reference.form-ref": "Form Reference",
  "menu.reference.form-ref.basic-form": "Basic Form",
  "menu.reference.form-ref.step-form": "Step Form",
  "menu.reference.form-ref.advanced-form": "Advanced Form",
  "menu.reference.profile-ref": "Profile Reference",
  "menu.reference.profile-ref.basic-profile": "Basic Profile",
  "menu.reference.profile-ref.advanced-profile": "Advanced Profile",
  "menu.reference.result-ref": "Result Reference",
  "menu.reference.result-ref.success": "Success",
  "menu.reference.result-ref.fail": "Fail",
  "menu.reference.exception-ref": "Exception Reference",
  "menu.reference.exception-ref.err403": "403",
  "menu.reference.exception-ref.err404": "404",
  "menu.reference.exception-ref.err500": "500",
};
